import { isProductModel } from '@masterofmalt/atom.componentlibrary/models/internal/product/IProductModel';

import { getProductDataLoaders } from '~/lib/atom/data-loader';
import { PriceConfig } from '~/lib/atom/types/price-config';

export interface RequestedProducts {
  id: number;
  quantity: number;
  price: number;
  index?: number;
  item_list_id?: string;
}

export const getItems = async (
  requestedProducts: RequestedProducts[],
  priceConfig: PriceConfig,
) => {
  const productDataLoader = getProductDataLoaders(priceConfig);

  const productResponse = await productDataLoader.loadMany(requestedProducts.map((p) => p.id));

  const products = productResponse.filter(isProductModel);

  return requestedProducts.map(({ id, quantity, price, item_list_id, index = undefined }) => {
    const product = products.find((p) => p.id === id);

    // If the product is not found, we'll still send a basic event
    if (!product) {
      return {
        item_id: id.toString(),
        price,
        quantity,
        index,
        item_list_id,
      };
    }

    return {
      item_id: id.toString(),
      item_name: product.name,
      item_brand: product.meta.bottler?.name || product.meta.distillery?.name,
      item_category: product.category.type?.name || undefined,
      item_category2: product.category.style?.name || undefined,
      item_image: product.imageUrlRelative || undefined,
      price,
      quantity,
      index,
      item_list_id,
    };
  });
};
